<template>
  <div class="withdraw-page">
    <van-nav-bar
      title="提现管理"
      left-arrow fixed placeholder
      @click-left="$router.back()"
    />

    <div class="balance-card">
      <div class="balance-label">可提现余额</div>
      <div class="balance-value">¥{{ formatNum(withdrawable) }}</div>
      <div class="balance-min">最低提现金额 ¥{{ minAmount }}</div>
    </div>

    <div class="form-card">
      <h4>申请提现</h4>
      <van-form @submit="onApply">
        <van-field
          v-model.number="amount"
          label="金额"
          placeholder="请输入提现金额"
          type="number"
          :rules="[{ required: true, message: '请输入金额' }]"
        >
          <template #left-icon>¥</template>
        </van-field>
        <van-field
          v-model="alipayAccount"
          label="支付宝"
          placeholder="请输入支付宝账号"
          :rules="[{ required: true, message: '请输入支付宝账号' }]"
        />
        <van-field
          v-model="realName"
          label="姓名"
          placeholder="请输入真实姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-button
          round block native-type="submit"
          :loading="applying"
          color="linear-gradient(135deg, #6366f1, #8b5cf6)"
          class="apply-btn"
        >
          提交申请
        </van-button>
      </van-form>
    </div>

    <div class="records-section">
      <h4>提现记录</h4>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="— 没有更多了 —"
        @load="onLoadRecords"
      >
        <div v-for="item in records" :key="item.id" class="record-card">
          <div class="record-top">
            <span class="record-amount">¥{{ item.amount }}</span>
            <van-tag :type="statusType(item.status)" size="small">
              {{ statusText(item.status) }}
            </van-tag>
          </div>
          <div class="record-date">{{ formatDate(item.createdAt) }}</div>
          <div v-if="item.status === 'rejected'" class="record-reason">
            驳回原因：{{ item.rejectReason }}
          </div>
        </div>
      </van-list>
      <van-empty
        v-if="!loading && records.length === 0"
        description="暂无提现记录"
      />
    </div>
  </div>
</template>

<script>
import { withdrawApi, bloggerApi } from '../api';

export default {
  data() {
    return {
      withdrawable: 0, minAmount: 10,
      amount: 0, alipayAccount: '', realName: '', applying: false,
      records: [], page: 1, size: 10, loading: false, finished: false
    };
  },
  created() { this.fetchProfile(); },
  methods: {
    async fetchProfile() {
      try {
        const res = await bloggerApi.getProfile();
        this.withdrawable = res.data.withdrawable;
        this.alipayAccount = res.data.alipayAccount || '';
        this.realName = res.data.realName || '';
      } catch (e) { /* ignore */ }
    },
    async onApply() {
      if (this.amount < this.minAmount) {
        this.$toast.fail('提现金额不能低于 ¥' + this.minAmount);
        return;
      }
      if (this.amount > this.withdrawable) {
        this.$toast.fail('可提现余额不足');
        return;
      }
      this.applying = true;
      try {
        await withdrawApi.apply({
          amount: this.amount,
          alipayAccount: this.alipayAccount,
          realName: this.realName
        });
        this.$toast.success('提现申请已提交');
        this.amount = 0;
        this.fetchProfile();
        this.onRefreshRecords();
      } finally { this.applying = false; }
    },
    async onLoadRecords() {
      const res = await withdrawApi.getMy({ page: this.page, size: this.size });
      const data = res.data;
      this.records = this.page === 1 ? data.list : [...this.records, ...data.list];
      this.loading = false;
      if (this.records.length >= data.total) this.finished = true;
      this.page++;
    },
    onRefreshRecords() {
      this.page = 1;
      this.finished = false;
      this.records = [];
      this.loading = true;
      this.onLoadRecords();
    },
    statusType(s) {
      return s === 'paid' ? 'success' : s === 'rejected' ? 'danger' : 'warning';
    },
    statusText(s) {
      return s === 'paid' ? '已打款' : s === 'rejected' ? '已驳回' : '待处理';
    },
    formatNum(n) {
      return (parseFloat(n) || 0).toFixed(2);
    },
    formatDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    }
  }
};
</script>

<style scoped>
.withdraw-page {
  min-height: 100vh; background: #f5f7fa; padding-bottom: 40px;
}
.balance-card {
  margin: 16px;
  padding: 24px; text-align: center;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-radius: 16px; color: #fff;
}
.balance-label { font-size: 13px; opacity: 0.85; }
.balance-value {
  font-size: 36px; font-weight: 800; margin: 4px 0;
}
.balance-min { font-size: 12px; opacity: 0.7; margin-top: 4px; }
.form-card {
  margin: 16px; padding: 16px;
  background: #fff; border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.form-card h4 {
  margin: 0 0 8px; font-size: 16px; color: #1f2937;
  padding-left: 4px;
}
.apply-btn { margin-top: 16px; }
.records-section {
  margin: 0 16px;
}
.records-section h4 {
  font-size: 16px; color: #1f2937; margin: 0 0 8px;
}
.record-card {
  background: #fff; border-radius: 10px; padding: 14px;
  margin-bottom: 8px; box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.record-top {
  display: flex; justify-content: space-between;
  align-items: center;
}
.record-amount {
  font-size: 16px; font-weight: 600; color: #1f2937;
}
.record-date {
  font-size: 12px; color: #9ca3af; margin-top: 4px;
}
.record-reason {
  margin-top: 6px; padding: 6px 8px;
  background: #fef2f2; border-radius: 6px;
  font-size: 12px; color: #ef4444;
}
</style>
